import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {PersianNumberService} from "ngx-persian";

@Pipe({
  name: 'numberText',
  standalone:true
})
export class NumberTextPipe implements PipeTransform {

  constructor(public persianNumberService:PersianNumberService,
              @Inject(LOCALE_ID) public locale: string) {
  }

  transform(value: string | number): string {
    if (this.locale == "fa") {
      try {
        return this.persianNumberService.toPersian(value);
      }catch (e) {
        return value+"";
      }
    }else{
      return value+"";
    }
  }

}
